import { render, staticRenderFns } from "./NewAdjudicatedProject.vue?vue&type=template&id=49fca897&scoped=true"
import script from "./NewAdjudicatedProject.vue?vue&type=script&lang=js"
export * from "./NewAdjudicatedProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fca897",
  null
  
)

export default component.exports